import { render, staticRenderFns } from "./TrialTests.vue?vue&type=template&id=32897a54"
import script from "./TrialTests.vue?vue&type=script&lang=js"
export * from "./TrialTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports